import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxLogger from 'redux-logger';
import rootReducer from './RootReducer.js'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'


// const persistConfig = {
//   key: 'root',
//   storage,
// }
 
// const persistedReducer = persistReducer(persistConfig, rootReducer)
 
// export default () => {
//   let store = createStore(persistedReducer, composeWithDevTools(
//     applyMiddleware(reduxLogger)
//   ))
//   let persistor = persistStore(store)
//   return { store, persistor }
// }



export const store = createStore(rootReducer, composeWithDevTools(
    applyMiddleware(reduxLogger)
    // other store enhancers if any
  ));

export const persistor = persistStore(store);

export default {store, persistor}; 